import React from 'react';
import { Alert, Badge } from 'react-bootstrap';

/**
 * WizardEnvironmentHeader - Persistent banner showing the active environment.
 * Displays a warning for production environments.
 */
const WizardEnvironmentHeader = ({ environment }) => {
  if (!environment) return null;

  const isProduction = environment === 'production';
  const variant = isProduction ? 'danger' : 'info';
  const label = environment.charAt(0).toUpperCase() + environment.slice(1);

  return (
    <Alert variant={variant} className="d-flex align-items-center justify-content-between mb-0 py-2">
      <div className="d-flex align-items-center gap-2">
        <strong>Provisioning Wizard</strong>
        <Badge bg={isProduction ? 'danger' : 'primary'}>{label} Environment</Badge>
      </div>
      {isProduction && (
        <span className="text-danger fw-bold">
          ⚠ Production provisioning is not available
        </span>
      )}
    </Alert>
  );
};

export default WizardEnvironmentHeader;
